var map = {
	"./En-us-been.ogg.mp3": 437,
	"./En-us-bill.ogg.mp3": 9813,
	"./En-us-called.ogg.mp3": 1950,
	"./En-us-free.ogg.mp3": 9529,
	"./En-us-little.ogg.mp3": 5373,
	"./bwill.wav": 7216,
	"./bwin.wav": 8932,
	"./cawd.wav": 7217,
	"./fwee.wav": 825,
	"./rickroll.mp3": 4259,
	"./wittle.wav": 4272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5294;